class CasaFragranceFilter extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[data-fragrance-choice]');
      if (!link || !this.contains(link)) return;
      const destination = new URL(link.href, window.location.origin);
      const parameters = new URLSearchParams(window.location.search);
      parameters.delete('page');
      destination.search = parameters.toString();
      link.href = destination.href;
      event.stopPropagation();
    }, { signal: this.abortController.signal });
  }
  disconnectedCallback() { this.abortController?.abort(); }
}
if (!customElements.get('casa-fragrance-filter')) {
  customElements.define('casa-fragrance-filter', CasaFragranceFilter);
}
